import { render, staticRenderFns } from "./EventPanel.vue?vue&type=template&id=7722c281&"
import script from "./EventPanel.vue?vue&type=script&lang=ts&"
export * from "./EventPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports